import "./HayaTasting.module.css";
import Cabecera from "@/reusable_sections/Header";
import EncabezadoDeCatas from "./sections/EncabezadoDeCatas";
import TastingInformation from "./sections/TastingInformation";
import ProximasFechas from "./sections/ProximasFechas";
import PieDePagena from "@/reusable_sections/Footer";
export default function HayaTastingPage() {
  return <div>
      <Cabecera />
      <EncabezadoDeCatas />
      <TastingInformation />
      <ProximasFechas />
      <PieDePagena />
    </div>;
}